import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { getSymbolERC20 } from '../utils/erc20Interactor';
import { approveTokenMarketplace } from "../utils/erc721Interactor";
import { listTokenMarketplace } from "../utils/marketPlaceInteractor";

function ListForm({ tokenId, reset,showLoader,hideLoader }) {

    const [isApproving, setIsApproving] = useState(true);
    const [price, setPrice] = useState(0);
    const [ERCSYMBOL, setERCSYMBOL] = useState('');

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            setIsApproving(true);
            const res = await approveTokenMarketplace(tokenId, confirmationCallback);
            setIsApproving(false);
        } catch (e) {
            toast.error('Please Approve Token!');
        } finally {
            hideLoader();
        }
        setERCSYMBOL(( await getSymbolERC20()));
    }

    const confirmationCallback = async () => {
        showLoader('Approving....')
    }

    const list = async () => {
        try {
            showLoader('Listing....')
            const res = await listTokenMarketplace(tokenId, price, 1);
        } catch (e) {
            toast.error('Something went wrong!')
        } finally {
            reset();
            hideLoader();
        }
    }

    return (<>
        {
            isApproving ? <p>Approve Your NFT for Marketplace</p> :
                <>
                    <h4>Create Listing</h4>
                    <div className="form-group acc-form mt-2">
                        <label>Price ({ERCSYMBOL})</label>
                        <input className="form-control" type="text" name="walletAddress" value={price}
                            onChange={({ currentTarget }) => setPrice(currentTarget.value)} />
                    </div>
                    <button onClick={list} className="btns accbtn-btn w-100" target="_blank">Create Listing</button>
                </>
        }
    </>);
}

export default ListForm;
